// m8-specific image component. Wraps the KTImageInput widget around the
// file picker; KT owns runtime interactions (change/cancel/remove + preview
// swap). The base base image is a thin file subclass with a JS-driven
// <img> preview; this m8 override exists so m8 retains today's KT chrome.
const component = require('../component/component');

const image = Object.assign({}, component, {
    subelements: {
        previewWrapper: false,
        // Outer KT widget host element. Default null so hasSubelement()
        // correctly reports absence in read-only mode (the template emits
        // a bare <img> tag with no widget markup).
        widgetHolder: null,
    },
    initialWebPath: '',

    init: function () {
        component.init.call(this);

        // Construct the KT image-input widget on the widget host. The
        // m8 behaviors.imageInput.create() adapter mirrors the
        // data-zit-image-input* attrs to data-kt-image-input* and then
        // constructs KTImageInput (idempotent — KTUtil.data binding).
        if (this.hasSubelement('widgetHolder')) {
            this.hm.behaviors.imageInput.create(this.subelements.widgetHolder);
        }

        if (this.initialWebPath) {
            // Workaround for CSP-blocked inline style attributes: set the
            // background-image at runtime so KT's chrome displays the
            // currently-stored image. KTImageInput repaints this on
            // change/cancel/remove, so this only seeds the initial state.
            this.subelements.previewWrapper.style.backgroundImage = 'url(' + this.initialWebPath + ')';
        }
    }
});

module.exports = image;
